import styled from 'styled-components';
import { FileModel } from 'services/EpdClient';
import { useTranslation } from 'react-i18next';
import FileService from 'services/FileService';
import DialogClearStyles, { DialogContent } from 'components/accounts/DialogClearStyles';
import { HeaderDialog } from 'styles/Styles.styled';

type Props = {
  isOpened: boolean;
  pcrType: 'main' | 'cpcr';
  onHide(): void;
  files: FileModel[];
};

const PcrSelectorFilesDialog: React.FC<Props> = ({ isOpened, pcrType, onHide, files }) => {
  const { t } = useTranslation();

  return (
    <DialogClearStyles
      header={<HeaderDialog>{pcrType === 'main' ? 'Download PCR' : 'Download c-PCR'}</HeaderDialog>}
      visible={isOpened}
      resizable={false}
      style={{ width: '35rem' }}
      onHide={onHide}
      footer={null}
    >
      <DialogContent>
        <PcrListFileTitle>Here you can download PCR related documents.</PcrListFileTitle>
        <List>
          {files.map((file) => (
            <PcrListFileItem key={file.id}>
              <span>{file.name || t('epdWizard.wizardStep1.pcrMenu.placeholderImage')}</span>
              <PcrListFileDownloadIcon
                className="pi pi-download"
                onClick={() => {
                  window.open(FileService.getImageUrl(file.id || ''), '_blank', 'noreferrer');
                }}
              />
            </PcrListFileItem>
          ))}
        </List>
      </DialogContent>
    </DialogClearStyles>
  );
};

export default PcrSelectorFilesDialog;

const PcrListFileTitle = styled.div`
  padding: 8px 16px;
  margin-bottom: 1rem;
  background-color: ${(props) => props.theme.colors.elementsFilledInput};
  border-radius: 4px;
  font-size: 14px;
`;

const List = styled.div`
  display: grid;
  gap: 16px;
`;

export const PcrListFileItem = styled.div`
  padding: 14px 16px;
  line-height: 20px;
  font-size: 14px;
  color: ${(props) => props.theme.colors.primaryBlack};
  background-color: ${(props) => props.theme.colors.secondaryLightGreen30};
  display: flex;
  justify-content: space-between;
  border-radius: 4px;
`;

const PcrListFileDownloadIcon = styled.i`
  align-self: center;
  font-weight: 700;
  cursor: pointer;
  color: ${(props) => props.theme.colors.primaryOrange};
  font-size: 16px;
`;
